import { render, staticRenderFns } from "./UrlDownloadLogs.vue?vue&type=template&id=2fac12ec&scoped=true"
import script from "./UrlDownloadLogs.vue?vue&type=script&lang=js"
export * from "./UrlDownloadLogs.vue?vue&type=script&lang=js"
import style0 from "./UrlDownloadLogs.vue?vue&type=style&index=0&id=2fac12ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fac12ec",
  null
  
)

export default component.exports